export default __webpack_public_path__ + "static/media/stapel_hardcase.aa085b80.png";